import React, { SetStateAction } from "react";
import DataTableControls from "../DataTableControls";
import TablePagination from "../pagination/TablePagination";
import DataTable from "./DataTable";
import InlineLoader from "../loader/InlineLoader";
import { LOADING_TEXT_TRANSLATIONS } from "../../translations/util";

interface IProps {
  selectedColumn: { id: string; value: string } | null;
  setSelectedColumn: React.Dispatch<
    SetStateAction<{ id: string; value: string } | null>
  >;
  filterColumns: Array<{ id: string; value: string }>;
  onSearch: (searchTerm?: string) => void;
  setShowAdvancedSearch?: React.Dispatch<SetStateAction<boolean>>;
  showCreateButton: boolean;
  showBulkUploadButton?: boolean;
  headers: Array<{ key: string; header: string; isSortable?: boolean }>;
  pageNum?: number;
  setPageNum?: (num: number) => void;
  onCreateButtonClick?: () => void;
  onBulkUploadButtonClick?: () => void;
  numberOfAdvancedSearchFilters?: number;
  clearAdvancedSearchFilters?: () => void;
  loading?: boolean;
  showTableControls?: boolean;
  totalItems?: number;
  totalPages?: number;
  pageSize?: number;
  setPageSize?: (num: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any;
  infoAlertHeading?: string;
  infoAlertSubtext?: string;
  showPagination?: boolean;
  showAdvancdSearch?: boolean;
  showSearch?: boolean;
  sortByField?: string;
  sortDirection?: "desc" | "asc";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSort?: any;
  isDFSIdataExists?: boolean;
  showIKICertificateDownloadButton?: boolean;
  onDownloadButtonClick?: () => void;
}

const DataTableWithControls = ({
  filterColumns,
  selectedColumn,
  setSelectedColumn,
  onSearch,
  setShowAdvancedSearch,
  showCreateButton,
  showBulkUploadButton,
  headers,
  pageNum,
  setPageNum,
  rows,
  infoAlertHeading,
  infoAlertSubtext,
  onCreateButtonClick,
  onBulkUploadButtonClick,
  onDownloadButtonClick,
  numberOfAdvancedSearchFilters,
  clearAdvancedSearchFilters,
  loading,
  totalItems = 99,
  totalPages = 99,
  pageSize = 20,
  setPageSize = () => null,
  showTableControls = true,
  showPagination = true,
  showAdvancdSearch = true,
  showSearch = true,
  sortByField,
  sortDirection,
  handleSort,
  isDFSIdataExists = false,
  showIKICertificateDownloadButton,
}: IProps) => {
  return (
    <div className="main-content">
      {showTableControls ? (
        <DataTableControls
          filterColumns={filterColumns}
          selectedColumn={selectedColumn}
          setSelectedColumn={setSelectedColumn}
          onSearch={onSearch}
          setShowAdvancedSearch={setShowAdvancedSearch}
          showCreateButton={showCreateButton}
          onCreateButtonClick={onCreateButtonClick}
          onBulkUploadButtonClick={onBulkUploadButtonClick}
          showAdvancdSearch={showAdvancdSearch}
          showSearch={showSearch}
          clearAdvancedSearchFilters={clearAdvancedSearchFilters}
          numberOfAdvancedSearchFilters={numberOfAdvancedSearchFilters}
          showBulkUploadButton={showBulkUploadButton}
          isDFSIdataExists={isDFSIdataExists}
          showIKICertificateDownloadButton={showIKICertificateDownloadButton}
          onDownloadButtonClick={onDownloadButtonClick}
        />
      ) : null}

      {loading ? (
        <InlineLoader
          description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
        />
      ) : (
        <>
          <DataTable
            rows={rows}
            infoAlertHeading={infoAlertHeading}
            infoAlertSubtext={infoAlertSubtext}
            headers={headers}
            sortByField={sortByField}
            sortDirection={sortDirection}
            handleSort={handleSort}
          />
          {showPagination ? (
            <TablePagination
              totalItems={totalItems}
              totalPages={totalPages}
              pageSize={pageSize}
              displayPageNum={pageNum}
              onPageChange={(pageNum: number) => {
                if (setPageNum) setPageNum(pageNum);
              }}
              onPageSizeChange={(pageNum: number) => {
                setPageSize(pageNum);
              }}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default DataTableWithControls;
